(function() {
    'use strict';

    angular
        .module('getwellApp')
        .controller('TreatmentExperienceDialogController', TreatmentExperienceDialogController);

    TreatmentExperienceDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', '$q', 'entity', 'TreatmentExperience', 'Booking', 'TreatmentExperienceResponse'];

    function TreatmentExperienceDialogController ($timeout, $scope, $stateParams, $uibModalInstance, $q, entity, TreatmentExperience, Booking, TreatmentExperienceResponse) {
        var vm = this;

        vm.treatmentExperience = entity;
        vm.clear = clear;
        vm.datePickerOpenStatus = {};
        vm.openCalendar = openCalendar;
        vm.save = save;

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            
            if(vm.treatmentExperience.booking != null && vm.treatmentExperience.booking.id == null) {
            	vm.treatmentExperience.booking = null;
            }
            
            if(vm.treatmentExperience.treatmentExperienceResponse != null && vm.treatmentExperience.treatmentExperienceResponse.id == null) {
            	vm.treatmentExperience.treatmentExperienceResponse = null;
            }
            
            if (vm.treatmentExperience.id !== null) {
                TreatmentExperience.update(vm.treatmentExperience, onSaveSuccess, onSaveError);
            } else {
                TreatmentExperience.save(vm.treatmentExperience, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('getwellApp:treatmentExperienceUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }

        vm.datePickerOpenStatus.date = false;

        function openCalendar (date) {
            vm.datePickerOpenStatus[date] = true;
        }
    }
})();
